import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Employee } from '../models/employee';
import { Account } from '../models/account';

@Injectable()
export class LoginEventsEmitter {
  private readonly currentEmployee = new Subject<Employee>();
  private readonly currentAccount = new Subject<Account>();
  private readonly _authorizationComplete = new BehaviorSubject<boolean>(false);

  currentEmployeeChanged$ = this.currentEmployee.asObservable();
  currentAccountChanged$ = this.currentAccount.asObservable();
  authorizationComplete$ = this._authorizationComplete.asObservable();

  broadcastCurrentEmployeeChanged(employee: Employee) {
    this.currentEmployee.next(employee);
  }

  broadcastCurrentAccountChanged(account: Account) {
    this.currentAccount.next(account);
  }

  broadcastAuthorizationComplete() {
    this._authorizationComplete.next(true);
  }

  public get authorizationComplete(): boolean {
    return this._authorizationComplete.getValue();
  }
}
